<ng-container>
	<ng-container *ngIf="theList$ | async as jobs">
		<ng-container *ngIf="jobs.length >= 1">
			<div *ngFor="let job of jobs | paginate: { itemsPerPage: pageSize, currentPage: currentPage, id: 'list' }; index as i; trackBy: trackByFunc">
				<flx-sp-detail-job-card
					[itemTwo]="job"
					[itemTwoContextMenuList]="itemTwoContextMenuList"
					[user]="user$ | async"
					[itemTwoPermissions]="itemTwoPermissions"
					[activeOrg]="activeOrg$ | async"
					[allInfo]="allInfo$ | async"
					[isOnline]="isOnline$ | async"
				>
				</flx-sp-detail-job-card>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
